import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/videos/video.hevc.mp4")